/// <amd-module name="typeahead/core/logging/Severity"/>

export enum Severity {
    MustFix, // for conditions that should not occur at all
    Excusable, // for conditions such as request timeout
    Negligible, // for errors that can be ignored silently
}
